






































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { EventEmitter } from 'events'
import { Device, DeviceListGroup } from '@/store/videoCallRoom/types'
import * as MediaDeviceTypes from '@/webrtc/constants/mediaDeviceTypes'

type InputeDeviceIDList = {
  [T in keyof DeviceListGroup]: string
}

const enum DeviceSettingToolEventTypes {
  CLICK_WINDOW
}

// Chrome for Android, Android Webviewなどでサポートなし
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId
export const isChangingOutputAudioDeviceSuported =
  typeof (document.createElement('audio') as ExHTMLMediaElement).setSinkId ===
  'function'

@Component
export default class VideoCallDeviceSettingTool extends Vue {
  $store!: ExStore

  readonly deviceTypes: Array<MediaDeviceKind> = [
    MediaDeviceTypes.VIDEO_INPUT,
    MediaDeviceTypes.AUDIO_INPUT,
    MediaDeviceTypes.AUDIO_OUTPUT
  ]

  readonly deviceSelectIconClasses = {
    [MediaDeviceTypes.VIDEO_INPUT]: 'fas fa-video',
    [MediaDeviceTypes.AUDIO_INPUT]: 'fas fa-microphone',
    [MediaDeviceTypes.AUDIO_OUTPUT]: 'fas fa-volume-up'
  }

  showDeviceSetting = false

  events = new EventEmitter()

  clickWindowHandler = (event: Event) =>
    this.events.emit(DeviceSettingToolEventTypes.CLICK_WINDOW, event)

  get devices() {
    return this.$store.getters['videoCallRoom/mediaDevices']
  }

  get selectedDevices() {
    return this.$store.getters['videoCallRoom/selectedDevices']
  }

  get inputDeviceIds() {
    const devices = this.selectedDevices
    return this.deviceTypes.reduce((ids, deviceType) => {
      return {
        ...ids,
        [deviceType]: devices[deviceType]
          ? (devices[deviceType] as Device).id
          : ''
      }
    }, {} as InputeDeviceIDList)
  }

  get deviceTypeSort() {
    return this.deviceTypes.filter(type => {
      switch (type) {
        case MediaDeviceTypes.VIDEO_INPUT:
        case MediaDeviceTypes.AUDIO_INPUT:
          return this.devices[type] != undefined

        default:
          return isChangingOutputAudioDeviceSuported
      }
    })
  }

  handleChangeDevice(type: MediaDeviceKind, event: Event) {
    if (!event.target) {
      return
    }

    this.showDeviceSetting = false
    this.events.removeAllListeners(DeviceSettingToolEventTypes.CLICK_WINDOW)
    const id = (event.target as HTMLSelectElement).value

    switch (type) {
      case MediaDeviceTypes.AUDIO_OUTPUT:
        this.$store.commit('videoCallRoom/setSelectedMediaDevice', {
          type,
          id
        })
        break
      default:
        this.$store.dispatch('videoCallRoom/updateSelectedMediaDevice', {
          type,
          id
        })
    }
  }

  handleClickDeviceSettingButton() {
    this.showDeviceSetting = !this.showDeviceSetting

    if (!this.showDeviceSetting) {
      return
    }

    const handler = (event: Event) => {
      const selectMenus = this.$refs.selectMenus as HTMLElement
      const targetElement = event.target as HTMLElement

      if (!selectMenus) {
        return
      }

      if (selectMenus.contains(targetElement)) {
        return
      }

      this.showDeviceSetting = false

      this.events.removeAllListeners(DeviceSettingToolEventTypes.CLICK_WINDOW)
    }

    window.setTimeout(
      () => this.events.on(DeviceSettingToolEventTypes.CLICK_WINDOW, handler),
      50
    )
  }

  created() {
    window.addEventListener('click', this.clickWindowHandler)
  }

  destroyed() {
    window.removeEventListener('click', this.clickWindowHandler)
  }
}
